import { appConstants } from '../../../constants'

const initialState = {
  list: [],
  listResult: {},
  loading: false
}

export const reducerQuisioner = (state = initialState, action) => {
  console.log(action.listResult)
  switch (action) {
    // case appConstants.GET_LIST_QUISIONER_SUCCESS :
    //   return {
    //     ...state,
    //     list: [...action.payload],
    //     loading: false
    //   }
    case appConstants.GET_LIST_QUISIONER_REQUEST : 
      return {
        ...state,
        loading: true
      }
    case appConstants.GET_RESULT_QUISIONER : 
      return {
        ...state,
        listResult: { ...action.listResult }
      }
    default :
      return state
  }
}